import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getPendingPaystackPayment } from "../utils/pendingPaystackPayment";

export default function PendingPaymentRecoveryGate() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.appState.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const pendingPayment = getPendingPaystackPayment();

    if (!pendingPayment?.reference || !pendingPayment?.returnPath) {
      return;
    }

    const currentPath = location.pathname;

    if (
      currentPath === pendingPayment.returnPath ||
      currentPath === "/payment/success"
    ) {
      return;
    }

    navigate(pendingPayment.returnPath);
  }, [isAuthenticated, location.pathname, navigate]);

  return null;
}
